export default {"src":"/_next/static/media/kitesurfing.4cad3ac2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};